import { useEffect, useState } from "react";
import { useSession } from "@/context/SessionContext";

const cache = new Map();
const TITLE = { customers: "name", vendors: "name", fleets: "name", drivers: "name", vehicles: "registration_number", parts: "name", services: "name", technicians: "name" };

export const clearLookups = () => cache.clear();
export const lookupLabel = (kind, d) => (d ? `${d[TITLE[kind]]}${d.code && kind !== "vehicles" ? ` · ${d.code}` : ""}` : "");

export function useLookup(kind, enabled = true) {
  const { api, scopeKey, can } = useSession();
  const perm = { customers: "customer", vendors: "vendor", fleets: "vehicle", vehicles: "vehicle", drivers: "driver", parts: "parts", services: "catalog", technicians: "workforce" }[kind];
  const allowed = enabled && can(`${perm}.view`);
  const key = `${scopeKey}|${kind}`;
  const [items, setItems] = useState(() => (cache.get(key)?.value) || null);

  useEffect(() => {
    if (!allowed) return undefined;
    let live = true;
    if (!cache.has(key)) {
      const entry = { promise: api.get("/lookups", { params: { kind } }).then((r) => { entry.value = r.data; return r.data; }).catch(() => []) };
      cache.set(key, entry);
    }
    cache.get(key).promise.then((v) => { if (live) setItems(v); });
    return () => { live = false; };
  }, [key, allowed, api, kind]);

  return { items: items || [], allowed };
}

export const RefLabel = ({ kind, id }) => {
  const { items, allowed } = useLookup(kind, !!id);
  if (!id) return <span className="text-muted-foreground">—</span>;
  if (!allowed) return <span className="text-muted-foreground">Restricted</span>;
  const d = items.find((x) => x.id === id);
  return <span>{d ? lookupLabel(kind, d) : <span className="text-muted-foreground">Inactive / unavailable</span>}</span>;
};
